/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import { FunctionComponent, useEffect } from 'react';

import { Locale, LocaleKeys } from '../../../../../core/locale';
import { KeyManager } from '../../../../../core/navigation';
import { NetworkManager } from '../../../../../core/network/NetworkManager';
import {
    RootState,
    useTivoDispatch,
    useTivoSelector,
} from '../../../../../core/tivo/tivo-redux-wrapper';
import { showWhisper } from '../../../../../store/whisper/whisper.reducer';
import { AntiburnOsd } from '../../../../common';
import { NoNetworkOverlay } from '../../../../NoNetworkOverlay';
import { Whisper } from '../../../../Whisper';
import { WhisperTypes } from '../../../../Whisper/WhisperTypes';
import { SettingsTemplate } from '../../../SettingsTemplate';

import './EmptyRecordingActivity.scss';

const EmptyRecordingActivity: FunctionComponent = (): JSX.Element => {
    const { isActive: isAntiBurnOsdActive } = useTivoSelector(
        (state: RootState) => state.antiburnOsd,
    );

    const dispatch = useTivoDispatch();

    useEffect(() => {
        const keyManagerIns: KeyManager = KeyManager.getInstance();
        if (keyManagerIns.isKeyIgnoring()) {
            keyManagerIns.stopKeyIgnoring();
        }
        if (NetworkManager.isNetworkDisconnected()) {
            dispatch(
                showWhisper({
                    message: NetworkManager.getNetworkDisconnectedMessage(),
                    iconType: WhisperTypes.INFO,
                }),
            );
        }
    }, []);

    return (
        <SettingsTemplate title={Locale.getString(LocaleKeys.RECORDING_ACTIVITY_TITLE)}>
            <div className="empty-recording-activity-container">
                <div className="empty-recording-activity-messages">
                    <div className="empty-recording-activity-message">
                        {Locale.getString(LocaleKeys.EMPTY_RECORDING_ACTIVITY_MESSAGE_FIRST_PART)}
                    </div>
                    <div className="empty-recording-activity-message">
                        {Locale.getString(LocaleKeys.EMPTY_RECORDING_ACTIVITY_MESSAGE_SECOND_PART)}
                    </div>
                </div>
                {isAntiBurnOsdActive && <AntiburnOsd />}
                <NoNetworkOverlay />
                <Whisper message="" />
            </div>
        </SettingsTemplate>
    );
};

export default EmptyRecordingActivity;
